import { validateApiResponse } from '../../../services';
import { listStudios } from '../../../services/studiosService';
import { useAsyncLoad } from './useAsyncLoad';

/** API studio (snake_case or camelCase) → the studio the role screens render. */
export const mapApiStudioToUi = (api) => ({
  id: api.id,
  name: api.name,
  description: api.description ?? '',
  icon: api.icon,
  tree: api.permissions ?? api.tree ?? [],
});

const NO_STUDIOS = Object.freeze([]);

const fetchStudios = () =>
  listStudios().then((res) => validateApiResponse(res, 'Could not load the studios').body.items.map(mapApiStudioToUi));

/**
 * Studios catalog with each studio's permission tree: `{ studios, isLoading, error }`.
 * Shared by the role detail (Permissions tab) and the role builder.
 */
export const useStudiosCatalog = () => {
  const { data, isLoading, error } = useAsyncLoad(fetchStudios, NO_STUDIOS);
  return { studios: data, isLoading, error };
};
